// extracted by mini-css-extract-plugin
export default {"list":"theatres_list__lHStY","map":"theatres_map__wpZ4n","search":"theatres_search__d9EiY"};